import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/screeningConfig',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/ScreeningConfigContainer',
      './modules/screeningConfig'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const ParticipantUpload = require('./containers/ScreeningConfigContainer').default
      const actions = require('./modules/screeningConfig')
      const reducer = require('./modules/screeningConfig').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'screeningConfig', reducer: reducer })

      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, ParticipantUpload)

    /* Webpack named bundle   */
    }, 'screeningConfig')
  }
})



// WEBPACK FOOTER //
// ./src/routes/ScreeningConfig/index.js